import { DismissButton, StyledSnackbar } from './style';
import { SuccessMessage } from './SuccessMessage';

type GivelifyNotificationProps = {
    text: string;
    isOpen: boolean;
    onClose: () => void;
};

export const GivelifyNotification: React.FC<GivelifyNotificationProps> = ({
    text,
    isOpen,
    onClose,
}) => {
    return isOpen ? (
        <StyledSnackbar
            open
            message={<SuccessMessage text={text} />}
            autoHideDuration={0}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            action={<DismissButton text="Dismiss" onClick={onClose} />}
        />
    ) : null;
};
